import {
  routerActions,
  routerMiddleware,
} from 'connected-react-router/immutable';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'hist... Remove this comment to see the full error message
import { createHashHistory } from 'history';
// eslint-disable-next-line import/no-deprecated -- Deprecated: **We recommend using the `configureStore` method
import { applyMiddleware, compose, createStore } from 'redux';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import reduxReset from 'redux-reset';
import thunk from 'redux-thunk';

import createRootReducer, { resetEnhancer } from './rootReducer';

const history = createHashHistory();

const rootReducer = createRootReducer(history);

const configureStore = (initialState: any) => {
  // Redux Configuration
  const middleware = [];
  const enhancers = [];

  // Thunk Middleware
  middleware.push(thunk);

  // Router Middleware
  const router = routerMiddleware(history);
  middleware.push(router);

  // Redux DevTools Configuration
  const actionCreators = {
    ...routerActions,
  };
  // If Redux DevTools Extension is installed use it, otherwise use Redux compose

  // @ts-expect-error TS(2339): Property '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' do... Remove this comment to see the full error message
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? // @ts-expect-error TS(2339): Property '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' do... Remove this comment to see the full error message
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Options: http://extension.remotedev.io/docs/API/Arguments.html
        actionCreators,
      })
    : compose;

  // Apply Middleware & Compose Enhancers
  enhancers.push(applyMiddleware(...middleware));
  enhancers.push(reduxReset());
  const enhancer = composeEnhancers(...enhancers);

  // Create Store
  // eslint-disable-next-line import/no-deprecated -- Deprecated: **We recommend using the `configureStore` method
  const store = createStore(resetEnhancer(rootReducer), initialState, enhancer);

  return store;
};

export default { configureStore, history };
